<div class="email-divider-container">
    <div class="email-divider" [ngStyle]="{'border-color':block.color?block.color:'#000'}"></div>
</div>